import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../globals';
import { AuthService } from '../_services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import _ from 'lodash';
import { CountryService } from '../_services/country.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public globals: Globals,
    public auth: AuthService,
    private snackBar: MatSnackBar,
    private countryService: CountryService,
  ) {}

  model: any = {};
  loginReady = false;
  showLoading = false;
  error = '';

  ngOnInit(): void {
    this.clearSession();

    const token = this.activatedRoute.snapshot.queryParams.token;
    // Auto-login using token from url
    if (token) {
      this.auth.token = token;
      // this.profileService.getProfile(0).then(
      //   prof => {
      //     this.globals.profile = new Profile();
      //     _.extend(this.globals.profile, prof);
      //     localStorage.setItem('currentUser', JSON.stringify({ username: prof.ID, token: token }));
      //     this.router.navigate(['/options']);
      //   }
      // ).catch(() => {
      //   this.loginReady = true;
      //   this.clearSession();
      // });
      this.router.navigate(['/home']);
    } else {
      this.loginReady = true;
    }
  }

  clearSession() {
    this.auth.logout();
    this.auth.token = null;
  }

  signIn() {
    if (_.isEmpty(this.model.username) || _.isEmpty(this.model.password)) {
      this.snackBar.open('Please enter username and password.', '', {
        duration: 2000,
      });
      return;
    }

    this.showLoading = true;

    this.auth.login(this.model.username, this.model.password).then((res) => {
      if (res === true) {
        // this.profileService.getProfile(0).then(
        //   prof => {
        //     this.globals.profile = new Profile();
        //     _.extend(this.globals.profile, prof);
        //     // store username and jwt token in local storage to keep user logged in between page refreshes
        //     localStorage.setItem('currentUser', JSON.stringify({ username: prof.ID, token: this.auth.token }));
        //     this.router.navigate(['/options']);
        //   }
        // ).catch(() => {
        //   this.clearSession();
        // });
        this.router.navigate(['/home']);
        this.countryService.getCountriesOld().subscribe((countries) => {
          this.globals.countriesArray = countries;
          countries.forEach((country, index, array) => {
            this.globals.countries[country.id] = country;
          });
        });
      } else {
        this.snackBar.open('Username or password is incorrect', 'Login failed', {
          duration: 2000,
        });
      }
      this.showLoading = false;
    });
  }
}
